<template>
  <div class="znzz">
      <div class="content">
        <div class="h1">共享共赢，赋能产业协同</div>
        <div class="h2">发布需求/入驻  >  匹配对接  >  在线协作  >  合作完成</div>
        <div class="h3">解决企业高端人才获取难、专业服务成本高、生产要素配置不均等问题</div>
        <div class="h4">
          <el-button type="primary" @click="go(1)">高端智力</el-button> <el-button  type="primary" @click="go(2)">创意设计</el-button> <el-button  type="primary" @click="go(3)">实体产能</el-button>
        </div>
      </div>
  </div>
</template>

<script>
import {networksecurityindex} from "../../request/moudle/shengtai";
export default {
  name: "",
  data(){
    return  {
      datas:'',
      number:0,
      moreList:[],
    }
  },
  created() {
    //this.loadconfig()
  },
  methods:{
    go(index){
     if(index==1){
        this.$router.push({
          path:'/gaoduan'
        });
     }else if(index==2){
       this.$router.push({
         path:'/chuangyi'
       });
     }else if(index==3){
       this.$router.push({
         path:'/shiti'
       });
     }
    },
    loadconfig(){
      this.$api.znzz.networksecurityindex().then((res)=>{
        this.datas=res.data
        this.moreList=res.data.moreList
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.znzz{
  width: 100%;
  height: 100vh;
  background: url("../../assets/shengtai/shengtai.png") no-repeat;
  background-size: 100% 100%;
}
.content{
  width: 1200px;
  margin: 0 auto;
  .h1{
    font-size: 36px;
    margin-top: 250px;
    font-weight: bolder;
  }
  .h2{
    font-size: 20px;
    line-height: 36px;
    padding: 24px 0;
  }
  .h3{
    font-size: 20px;
    color: #666666;
    line-height: 36px;
    margin-bottom: 36px;
  }
}
</style>